import styled from "styled-components";

export const Item = styled.li`
  list-style-type: none;
  line-height: 1.6;

  @media (min-width: 1440px) {
    padding: 5px 0;
  }
`;
